"use strict";

import ItemContentView from "/js/interaction-views/item-content-view.js";
import Util from "/js/util/util.js";
import AppUtil from "/js/util/app-util.js";
import AnimSequencer from "/js/util/anim-sequencer.js";
import Constants from "/js/core/constants.js";
import FocusUtil from '/js/util/focus-util.js';
import Autoshrink from "/js/util/autoshrink.js";
import CssUtil from '../util/css-util';

/**
 * View consists of a "panel" with either question text or an image, and a yes and no button.
 */
export default class BinaryButtonItemContentView extends ItemContentView {

  #$button1;
  #$button2;
  #$feedbackScreen;
  #$feedbackGraphicYes;
  #$feedbackGraphicNo;

  constructor(questionObject, index, numItems) {

    super(questionObject, index, numItems);

    const accessibilityAttributes = questionObject.accessibilityDescription
        ? `aria-label="${questionObject.accessibilityDescription}" role="img"`
        : ``;
    const s = `\
        <div class="panel">
          <div class="textContent"><div class="text">${ this.questionObject.innerText }</div></div>
          <div class="imageContent" ${accessibilityAttributes}></div>
          <div class="feedbackScreen"></div>
          <div class="feedbackGraphicYes"></div>
          <div class="feedbackGraphicNo"></div>
          <div class="button1" tabindex="${Constants.TABINDEX_CONTENT_GENERAL}"><div class="text">${ this.questionObject.buttons[0] }</div></div>
          <div class="button2" tabindex="${Constants.TABINDEX_CONTENT_GENERAL + 1}"><div class="text">${ this.questionObject.buttons[1] }</div></div>
        </div>`;
    const $els = $(s);
    this.$content.append($els);

    this.#$button1 = this.$el.find(".button1");
    this.#$button2 = this.$el.find(".button2");

    this.#$button1.click(e => this.#onButton(e));
    this.#$button2.click(e => this.#onButton(e));

    FocusUtil.doStandardTreatment(this.#$button1);
    FocusUtil.doStandardTreatment(this.#$button2);

    this.#$feedbackScreen = this.$el.find(".feedbackScreen");
    this.#$feedbackGraphicYes = this.$el.find(".feedbackGraphicYes");
    this.#$feedbackGraphicNo = this.$el.find(".feedbackGraphicNo");

    // Show either the text holder or the image holder
    const $textContent = this.$el.find(".textContent");
    const $imageContent = this.$el.find(".imageContent");
    if (questionObject.innerText) {
      $imageContent.css('display', 'none');
      $textContent.css('display', 'block');
    } else if (questionObject.image) {
      $textContent.css('display', 'none');
      $imageContent.css('display', 'block');
      const url = AppUtil.makeLessonAssetPath(questionObject.image);
      const imageUrl = `url("${url}")`;
      $imageContent.css('background-image', imageUrl);
    }
  }

  /* Override */
  onShow() {
    super.onShow();

    // Autoshrink prompt text to prevent content view from overflowing too much
    // within its scrollable container.
    Autoshrink.go(85, this.$prompt);

    // Autoshrink text inside 'panel'
    const $textContent = this.$el.find(".textContent");
    if (CssUtil.isDisplayBlock($textContent)) {
      const $text = $textContent.find(".text");
      Autoshrink.go($textContent, $text);
    }
  }

  #onButton(e) {
    // Show feedback anim.
    const buttonIndex = (e.currentTarget === this.#$button1[0]) ? 0 : 1;
    const isCorrect = (buttonIndex === this.questionObject.answer);
    const $graphic = isCorrect ? this.#$feedbackGraphicYes : this.#$feedbackGraphicNo;
    this.#$feedbackScreen.show();
    $graphic.show();
    AppUtil.setCssWithoutTransition($graphic, () => { 
        Util.setTranslationAndScale($graphic, "-50%", "-50%", 0); 
    });
    
    Util.setTranslationAndScale($graphic, "-50%", "-50%", 1.0);
    
    const anim = new AnimSequencer();
    anim.addAnim(this.#$feedbackScreen, () => { 
      this.#$feedbackScreen.css("opacity", "1"); 
    });
    anim.addAnim(this.#$feedbackScreen, () => { this.#$feedbackScreen.css("opacity", "0.98"); }); // creates extra delay :/
    anim.setCallback(() => { this.$el.trigger('content-view', isCorrect); });
    anim.run();
  }
}
